// LAVIKA Theme JS — Clean Cart Build
'use strict';

window.LavikaLog = function (m) { try { console.log('[Lavika] ' + m); } catch (e) { } };
LavikaLog('loaded');

window.LavikaQ = function (s, c) { try { return (c || document).querySelector(s); } catch (e) { return null; } };
window.LavikaQA = function (s, c) { try { return Array.prototype.slice.call((c || document).querySelectorAll(s)); } catch (e) { return []; } };

window.LavikaFormatMoney = function (cents) {
  try {
    var format = (window.Lavika && window.Lavika.settings && window.Lavika.settings.moneyFormat) || 'Rs. {{amount}}';
    var placeholder = format.match(/\{\{\s*\w+\s*\}\}/);
    var prefix = 'Rs. ';
    var suffix = '';
    if (placeholder) {
      var parts = format.split(placeholder[0]);
      prefix = parts[0] || '';
      suffix = parts[1] || '';
    }
    var n = Number((Math.round(cents) / 100).toFixed(0));
    return prefix + n.toLocaleString('en-IN') + suffix;
  } catch (e) {
    try { return 'Rs. ' + Math.round(cents / 100); } catch (_) { return ''; }
  }
};

window.LavikaFormatPrice = function (priceStr) {
  try {
    var format = (window.Lavika && window.Lavika.settings && window.Lavika.settings.moneyFormat) || 'Rs. {{amount}}';
    var placeholder = format.match(/\{\{\s*\w+\s*\}\}/);
    var prefix = 'Rs. ';
    var suffix = '';
    if (placeholder) {
      var parts = format.split(placeholder[0]);
      prefix = parts[0] || '';
      suffix = parts[1] || '';
    }
    var n = parseFloat(priceStr);
    if (isNaN(n) || n < 0) return prefix + (priceStr || '0') + suffix;
    return prefix + Number(n.toFixed(0)).toLocaleString('en-IN') + suffix;
  } catch (e) { return 'Rs. ' + (priceStr || '0'); }
};

window.LavikaToast = function (msg, type) {
  try {
    type = type || '';
    var t = LavikaQ('.toast');
    if (!t && document.body) {
      t = document.createElement('div');
      t.className = 'toast';
      document.body.appendChild(t);
    }
    if (!t) return;
    t.className = 'toast toast--' + type;
    t.textContent = msg;
    setTimeout(function () { try { t.classList.add('is-visible'); } catch (_) { } }, 20);
    setTimeout(function () { try { t.classList.remove('is-visible'); } catch (_) { } }, 2400);
  } catch (e) { }
};

window.LavikaSetLoading = function (on) {
  try {
    var drawer = LavikaQ('[data-cart-drawer]');
    if (drawer) {
      if (on) {
        drawer.classList.add('is-loading');
        if (window.LavikaCartSkeletonTimeout) {
          clearTimeout(window.LavikaCartSkeletonTimeout);
        }
        window.LavikaCartSkeletonTimeout = setTimeout(function () {
          drawer.classList.add('is-loading-skeleton');
        }, 150);
      } else {
        drawer.classList.remove('is-loading');
        if (window.LavikaCartSkeletonTimeout) {
          clearTimeout(window.LavikaCartSkeletonTimeout);
          window.LavikaCartSkeletonTimeout = null;
        }
        drawer.classList.remove('is-loading-skeleton');
      }
    }
  } catch (e) { }
};

window.LavikaFetch = function (url, data) {
  var formData = new FormData();
  if (data) {
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        formData.append(key, data[key]);
      }
    }
  }
  return fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json'
    },
    body: formData
  }).then(function (r) {
    if (!r.ok) {
      return r.json().then(function (err) { throw err; });
    }
    return r.json();
  });
};

window.LavikaGetCart = function () {
  return fetch('/cart.js?v=' + new Date().getTime()).then(function (r) { return r.json(); });
};

window.LavikaWithSkeleton = function (fetchPromise, startSkeletonFn, stopSkeletonFn, delay) {
  delay = typeof delay === 'number' ? delay : 150;
  var skeletonShown = false;
  var timeoutId = setTimeout(function () {
    skeletonShown = true;
    startSkeletonFn();
  }, delay);

  return fetchPromise.then(function (res) {
    clearTimeout(timeoutId);
    if (skeletonShown) {
      stopSkeletonFn();
    }
    return res;
  }).catch(function (err) {
    clearTimeout(timeoutId);
    if (skeletonShown) {
      stopSkeletonFn();
    }
    throw err;
  });
};

window.LavikaParseDataSettings = function () {
  var settings = (window.Lavika && window.Lavika.settings) || {};
  try {
    var drawerEl = window.LavikaQ && window.LavikaQ('[data-cart-drawer]');
    if (drawerEl) {
      if (drawerEl.getAttribute('data-show-rewards') !== null) {
        settings.showRewardsTracker = (drawerEl.getAttribute('data-show-rewards') === 'true');
      }
      if (drawerEl.getAttribute('data-show-savings') !== null) {
        settings.showSavingsBanner = (drawerEl.getAttribute('data-show-savings') === 'true');
      }
      if (drawerEl.getAttribute('data-enable-confetti') !== null) {
        settings.enableConfetti = (drawerEl.getAttribute('data-enable-confetti') === 'true');
      }
      if (drawerEl.getAttribute('data-tier2-variant') !== null) {
        settings.tier2VariantId = drawerEl.getAttribute('data-tier2-variant');
      }
      if (drawerEl.getAttribute('data-tier3-variant') !== null) {
        settings.tier3VariantId = drawerEl.getAttribute('data-tier3-variant');
      }
      if (drawerEl.getAttribute('data-enable-upsells') !== null) {
        settings.enableUpsells = (drawerEl.getAttribute('data-enable-upsells') === 'true');
      }
      if (drawerEl.getAttribute('data-upsell-heading') !== null) {
        settings.upsellHeading = drawerEl.getAttribute('data-upsell-heading');
      }
      if (drawerEl.getAttribute('data-upsell-limit') !== null) {
        settings.upsellLimit = parseInt(drawerEl.getAttribute('data-upsell-limit'), 10) || 3;
      }
      if (drawerEl.getAttribute('data-upsell-style') !== null) {
        settings.upsellStyle = drawerEl.getAttribute('data-upsell-style');
      }
      if (drawerEl.getAttribute('data-tier1-threshold') !== null) {
        settings.tierShipping = drawerEl.getAttribute('data-tier1-threshold');
      }
      if (drawerEl.getAttribute('data-tier1-label') !== null) {
        settings.tierShippingLabel = drawerEl.getAttribute('data-tier1-label');
      }
      if (drawerEl.getAttribute('data-tier2-threshold') !== null) {
        settings.tierGift = drawerEl.getAttribute('data-tier2-threshold');
      }
      if (drawerEl.getAttribute('data-tier2-label') !== null) {
        settings.tierGiftLabel = drawerEl.getAttribute('data-tier2-label');
      }
      if (drawerEl.getAttribute('data-tier3-threshold') !== null) {
        settings.tierOrganiser = drawerEl.getAttribute('data-tier3-threshold');
      }
      if (drawerEl.getAttribute('data-tier3-label') !== null) {
        settings.tierOrganiserLabel = drawerEl.getAttribute('data-tier3-label');
      }
      if (drawerEl.getAttribute('data-savings-low-text') !== null) {
        settings.savingsLowText = drawerEl.getAttribute('data-savings-low-text');
      }
      if (drawerEl.getAttribute('data-savings-high-text') !== null) {
        settings.savingsHighText = drawerEl.getAttribute('data-savings-high-text');
      }
    }
  } catch (e) {
    console.warn('[Lavika] Failed to parse drawer data-attributes:', e);
  }
  return settings;
};

window.LavikaGetTiers = function () {
  var s = window.LavikaParseDataSettings();
  function parseVal(val, defaultVal) {
    if (val === undefined || val === null) return defaultVal * 100;
    var clean = String(val).replace(/[^0-9.]/g, '');
    var parsed = parseFloat(clean);
    return (isNaN(parsed) ? defaultVal : parsed) * 100;
  }
  return [
    { id: 'shipping', threshold: parseVal(s.tierShipping, 599), name: s.tierShippingLabel || 'Free Shipping', emoji: '\uD83D\uDE9A' },
    { id: 'gift', threshold: parseVal(s.tierGift, 699), name: s.tierGiftLabel || 'Free Gift', emoji: '\uD83C\uDF81' },
    { id: 'organiser', threshold: parseVal(s.tierOrganiser, 1199), name: s.tierOrganiserLabel || 'Free Organiser', emoji: '\uD83C\uDF8C' }
  ];
};

window.LavikaEscape = function (s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
};

window.LavikaRender = {
  header: function (cart) {
    try {
      LavikaQA('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });

      var pillEl = LavikaQ('[data-cart-count-pill]');
      if (pillEl) {
        var prev = parseInt(pillEl.textContent, 10);
        if (!isNaN(prev) && prev !== cart.item_count) {
          pillEl.classList.remove('is-bumped');
          void pillEl.offsetWidth;
          pillEl.classList.add('is-bumped');
        }
        pillEl.textContent = cart.item_count;
      }

      var subCountEl = LavikaQ('[data-cart-sub-count]');
      if (subCountEl) {
        subCountEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item selected' : ' items selected');
      }

      var totalSavings = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var compareAt = window.LavikaCompareAtMap && window.LavikaCompareAtMap[item.variant_id];
        if (compareAt && compareAt > item.price) {
          totalSavings += (compareAt - item.price) * item.quantity;
        } else if (item.original_line_price > item.final_line_price) {
          totalSavings += (item.original_line_price - item.final_line_price);
        }
      }

      var savingsGroup = LavikaQ('[data-cart-header-savings-group]');
      if (savingsGroup) {
        if (totalSavings > 0) {
          savingsGroup.style.display = 'flex';
          var savingsText = LavikaQ('[data-cart-header-savings-text]');
          if (savingsText) savingsText.textContent = 'You save ' + LavikaFormatMoney(totalSavings);
        } else {
          savingsGroup.style.display = 'none';
        }
      }

      var headerTotal = LavikaQ('[data-cart-header-total-text]');
      if (headerTotal) {
        headerTotal.textContent = LavikaFormatMoney(cart.total_price);
      }
    } catch (e) { }
  },

  progress: function (cart) {
    try {
      var s = window.LavikaParseDataSettings();
      var progressEl = LavikaQ('[data-cart-progress]');
      if (progressEl) {
        if (s.showRewardsTracker === false) {
          progressEl.style.display = 'none';
        } else {
          progressEl.style.display = '';
        }
      }

      var tiers = LavikaGetTiers();
      var total = parseFloat(cart.total_price) || 0;
      var tier1_threshold = tiers[0].threshold;
      var tier2_threshold = tiers[1].threshold;
      var tier3_threshold = tiers[2].threshold;

      if (progressEl) {
        var isUnlocked = total >= tier3_threshold;
        var wasUnlocked = progressEl.classList.contains('is-fully-unlocked');
        progressEl.classList.toggle('is-fully-unlocked', isUnlocked);

        if (isUnlocked && !wasUnlocked && !window.LavikaCelebrationPlayed) {
          progressEl.classList.add('trigger-celebration');
          window.LavikaCelebrationPlayed = true;
          setTimeout(function () {
            progressEl.classList.remove('trigger-celebration');
          }, 1000);
        } else if (!isUnlocked) {
          window.LavikaCelebrationPlayed = false;
        }
      }

      var pct = 0;
      if (total > 0) {
        if (total < tier1_threshold) {
          pct = (total / tier1_threshold) * 10;
        } else if (total < tier2_threshold) {
          pct = 10 + ((total - tier1_threshold) / (tier2_threshold - tier1_threshold)) * (50 - 10);
        } else if (total < tier3_threshold) {
          pct = 50 + ((total - tier2_threshold) / (tier3_threshold - tier2_threshold)) * (90 - 50);
        } else {
          pct = 90 + Math.min(10, ((total - tier3_threshold) / tier3_threshold) * 10);
        }
      }

      var fill = LavikaQ('[data-progress-fill]');
      if (fill) fill.style.width = pct.toFixed(2) + '%';

      var cleanThreshold = function (val) {
        var clean = String(val || '').replace(/[^0-9.]/g, '');
        return (parseFloat(clean) || 0) * 100;
      };

      var headlineEl = LavikaQ('[data-progress-headline]');
      var subtitleEl = LavikaQ('[data-progress-subtitle]');
      var motivationEl = LavikaQ('[data-progress-motivation]');

      if (headlineEl) {
        headlineEl.innerHTML = '<span>✨ Unlock Your Free Organizer</span>';
      }

      if (subtitleEl) {
        if (total < tier3_threshold) {
          var diff = tier3_threshold - total;
          subtitleEl.innerHTML = '<span>Only <strong class="highlight-pink">' + LavikaFormatMoney(diff) + '</strong> More</span>';
        } else {
          subtitleEl.innerHTML = '';
        }
      }

      if (motivationEl) {
        if (total < tier3_threshold) {
          motivationEl.innerHTML = '<span>FREE Premium Organizer • Worth ₹1299</span>';
          motivationEl.style.display = '';
        } else {
          motivationEl.innerHTML = '';
          motivationEl.style.display = 'none';
        }
      }

      // Update milestones checkpoints
      LavikaQA('[data-checkpoint]').forEach(function (el) {
        var thr = cleanThreshold(el.dataset.threshold);
        var isAchieved = total >= thr;
        el.classList.toggle('is-achieved', isAchieved);
      });

      // Update milestone label colors
      var labelMap = { shipping: tier1_threshold, gift: tier2_threshold, organiser: tier3_threshold };
      LavikaQA('[data-label-tier]').forEach(function (el) {
        var tier = el.dataset.labelTier;
        var thr = labelMap[tier] || 0;
        el.classList.toggle('is-achieved', total >= thr);
      });
    } catch (e) { }
  },

  items: function (cart) {
    try {
      var wrap = LavikaQ('ul[data-cart-items]');
      var empty = LavikaQ('.cart-drawer__empty');
      var foot = LavikaQ('[data-cart-foot]');
      if (!wrap) return;

      if (cart.item_count === 0) {
        if (empty) empty.hidden = false;
        wrap.innerHTML = '';
        if (foot) foot.hidden = true;

        var unlockedCard = LavikaQ('[data-unlocked-rewards-card]');
        if (unlockedCard) unlockedCard.style.display = 'none';

        var savingsBannerEl = LavikaQ('[data-cart-savings-banner]');
        if (savingsBannerEl) savingsBannerEl.style.display = 'none';
        return;
      }

      if (empty) empty.hidden = true;
      if (foot) foot.hidden = false;

      var settings = window.LavikaParseDataSettings();
      var tier2VarId = settings.tier2VariantId ? String(settings.tier2VariantId) : '';
      var tier3VarId = settings.tier3VariantId ? String(settings.tier3VariantId) : '';

      var getImgUrl = function (item) {
        if (!item) return '';
        var rawImg = item.image
          || (item.featured_image && (item.featured_image.url || item.featured_image))
          || '';
        if (typeof rawImg === 'object' && rawImg !== null) {
          rawImg = rawImg.url || rawImg.src || '';
        }
        return String(rawImg || '');
      };

      var html = '';
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var itemVarId = String(item.variant_id);

        if (settings.showRewardsTracker !== false) {
          if (itemVarId === tier3VarId || (tier2VarId && itemVarId === tier2VarId)) {
            continue;
          }
        }

        var key = LavikaEscape(item.key);
        var title = LavikaEscape(item.product_title);
        var url = LavikaEscape(item.url);
        var img = getImgUrl(item);
        var line = i + 1;

        var badgeText = '';
        var mod = line % 3;
        if (mod === 1) {
          badgeText = 'BESTSELLER';
        } else if (mod === 2) {
          badgeText = 'TRENDING';
        } else {
          badgeText = 'LIMITED STOCK';
        }
        var badgeHtml = '<span class="cart-drawer__item-badge-tag">' + badgeText + '</span>';

        var priceHtml = '';
        var compareAt = window.LavikaCompareAtMap && window.LavikaCompareAtMap[item.variant_id];
        var itemFinalPrice = item.final_line_price;
        var itemCompareAtPrice = compareAt ? (compareAt * item.quantity) : 0;
        var itemSavings = 0;

        if (itemCompareAtPrice > itemFinalPrice) {
          itemSavings = itemCompareAtPrice - itemFinalPrice;
        } else if (item.original_line_price !== item.final_line_price) {
          itemSavings = item.original_line_price - itemFinalPrice;
        }

        priceHtml += '<span class="cart-drawer__item-price-now">' + LavikaFormatMoney(item.final_line_price) + '</span>';
        if (itemCompareAtPrice > itemFinalPrice) {
          priceHtml += '<span class="cart-drawer__item-price-was">' + LavikaFormatMoney(itemCompareAtPrice) + '</span>';
        } else if (item.original_line_price !== item.final_line_price) {
          priceHtml += '<span class="cart-drawer__item-price-was">' + LavikaFormatMoney(item.original_line_price) + '</span>';
        }
        if (itemSavings > 0) {
          priceHtml += '<span class="cart-drawer__item-savings-chip">Save ' + LavikaFormatMoney(itemSavings) + '</span>';
        }
        if (item.quantity > 1) {
          priceHtml += '<span class="cart-drawer__item-price-each">' + LavikaFormatMoney(item.final_line_price / item.quantity) + ' each</span>';
        }

        var imgHtml = img ? '<img src="' + img + '" loading="lazy" alt="">' : '<div class="cart-drawer__item-img-ph">\uD83D\uDDBC\uFE0F</div>';
        var variantHtml = '';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          variantHtml = '<p class="cart-drawer__item-variant">' + LavikaEscape(item.variant_title) + '</p>';
        }

        var propertiesHtml = '';
        if (item.properties && Object.keys(item.properties).length > 0) {
          var propsArray = [];
          var propKeys = Object.keys(item.properties).sort();
          propKeys.forEach(function (propName) {
            var propVal = item.properties[propName];
            if (propName.indexOf('_') !== 0 && propVal) {
              propsArray.push(propVal);
            }
          });
          if (propsArray.length > 0) {
            propertiesHtml += '<ol class="cart-item-properties" style="margin: 6px 0 0; padding-left: 14px; font-size: 12px; color: #555; line-height: 1.4; list-style-type: decimal;">';
            propsArray.forEach(function (pVal) {
              propertiesHtml += '<li>' + LavikaEscape(pVal) + '</li>';
            });
            propertiesHtml += '</ol>';
          }
        }

        html += '<li class="cart-drawer__item" data-line-key="' + key + '" data-line="' + line + '">' +
          '<a href="' + url + '" class="cart-drawer__item-img">' + imgHtml + badgeHtml + '</a>' +
          '<div class="cart-drawer__item-info">' +
          '<div class="cart-drawer__item-title-row">' +
          '<a href="' + url + '" class="cart-drawer__item-name">' + title + '</a>' +
          '<button type="button" class="cart-drawer__item-remove" data-remove-line="' + key + '" aria-label="Remove">' +
          '<svg class="cart-drawer__item-remove-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>' +
          '</button>' +
          '</div>' +
          variantHtml +
          propertiesHtml +
          '<div class="cart-drawer__item-meta-row">' +
          '<div class="cart-drawer__item-price">' + priceHtml + '</div>' +
          '<div class="qty-stepper qty-stepper--sm">' +
          '<button type="button" class="qty-stepper__btn" data-step="dec" aria-label="Decrease">\u2212</button>' +
          '<input type="number" class="qty-stepper__input" value="' + item.quantity + '" min="1" data-line="' + line + '" data-line-key="' + key + '" aria-label="Quantity">' +
          '<button type="button" class="qty-stepper__btn" data-step="inc" aria-label="Increase">+</button>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '</li>';
      }
      wrap.innerHTML = html;

      var unlockedCard = LavikaQ('[data-unlocked-rewards-card]');
      var giftRow = LavikaQ('[data-reward-row="gift"]');
      var organiserRow = LavikaQ('[data-reward-row="organiser"]');

      var total = parseFloat(cart.total_price) || 0;
      var tiers = LavikaGetTiers();
      var tier2_threshold = tiers[1].threshold;
      var tier3_threshold = tiers[2].threshold;

      var giftAchieved = (total >= tier2_threshold);
      var orgAchieved = (total >= tier3_threshold);

      // Unlocked rewards card is no longer used — State 2 celebration handles it
      if (unlockedCard) {
        unlockedCard.style.display = 'none';
      }
      if (giftRow) {
        giftRow.style.display = 'none';
      }
      if (organiserRow) {
        organiserRow.style.display = 'none';
      }
      var rewardDivider = LavikaQ('[data-reward-divider]');
      if (rewardDivider) {
        rewardDivider.style.display = 'none';
      }

    } catch (e) { try { console.warn('[Lavika] items render err:', e); } catch (_) { } }
  },

  upsell: function (cart) {
    try {
      var el = LavikaQ('[data-cart-upsell]');
      if (!el) return;
      var settings = window.LavikaParseDataSettings();
      if (settings.enableUpsells === false || cart.item_count === 0) {
        el.setAttribute('hidden', '');
      } else {
        el.removeAttribute('hidden');
        var titleTextEl = el.querySelector('.upsell-title-text');
        var titleEl = el.querySelector('.cart-drawer__upsell-title');
        if (titleTextEl && settings.upsellHeading) {
          titleTextEl.textContent = settings.upsellHeading;
        } else if (titleEl && settings.upsellHeading) {
          titleEl.textContent = settings.upsellHeading;
        }
        el.className = 'cart-drawer__upsell cart-drawer__upsell--' + (settings.upsellStyle || 'style_1');
        if (typeof window.LavikaLoadUpsell === 'function') window.LavikaLoadUpsell(cart);
      }
    } catch (e) { }
  },

  footer: function (cart) {
    try {
      var settings = window.LavikaParseDataSettings();
      var tier2VarId = settings.tier2VariantId ? String(settings.tier2VariantId) : '';
      var tier3VarId = settings.tier3VariantId ? String(settings.tier3VariantId) : '';
      var giftThreshold = (parseFloat(settings.tierGift) || 699) * 100;
      var organiserThreshold = (parseFloat(settings.tierOrganiser) || 1199) * 100;

      // Values for rewards
      var giftValue = 29900; // Default ₹299
      var organiserValue = 120000; // Default ₹1,200

      var original_subtotal = 0;
      var mrp_discount = 0;
      var rewards_discount = 0;

      var organiserInCart = false;
      var giftInCart = false;
      var organiserComparePrice = organiserValue;

      // First pass: count actual cart items
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var isOrganiser = (String(item.variant_id) === tier3VarId);
        var isGift = (tier2VarId && String(item.variant_id) === tier2VarId);

        var compareAt = window.LavikaCompareAtMap && window.LavikaCompareAtMap[item.variant_id];
        var itemComparePrice = compareAt || item.original_price || item.price;

        if (isOrganiser) {
          organiserInCart = true;
          organiserComparePrice = itemComparePrice || organiserValue;
          original_subtotal += organiserComparePrice * item.quantity;
          rewards_discount += organiserComparePrice * item.quantity;
        } else if (isGift) {
          giftInCart = true;
          original_subtotal += giftValue * item.quantity;
          rewards_discount += giftValue * item.quantity;
        } else {
          var lineOriginal = itemComparePrice * item.quantity;
          original_subtotal += lineOriginal;

          var lineSavings = Math.max(0, lineOriginal - item.final_line_price);
          mrp_discount += lineSavings;
        }
      }

      // Check for active rewards based on total price before rewards
      var totalForThreshold = cart.total_price;
      if (organiserInCart || giftInCart) {
        var rewardsPrice = 0;
        for (var j = 0; j < cart.items.length; j++) {
          var idStr = String(cart.items[j].variant_id);
          if (idStr === tier3VarId || idStr === tier2VarId) {
            rewardsPrice += (cart.items[j].final_line_price || 0);
          }
        }
        totalForThreshold = cart.total_price - rewardsPrice;
      }

      var giftActive = (settings.showRewardsTracker !== false && totalForThreshold >= giftThreshold);
      var organiserActive = (settings.showRewardsTracker !== false && totalForThreshold >= organiserThreshold);

      // Ensure we account for these in the subtotal and savings if they are active but not in cart yet
      if (giftActive && !giftInCart) {
        original_subtotal += giftValue;
        rewards_discount += giftValue;
      }
      if (organiserActive && !organiserInCart) {
        original_subtotal += organiserComparePrice;
        rewards_discount += organiserComparePrice;
      }

      var total_discounts_applied = mrp_discount + rewards_discount;

      // Update Subtotal Count
      var subtotalItemsEl = LavikaQ('[data-cart-subtotal-items]');
      if (subtotalItemsEl) subtotalItemsEl.textContent = cart.item_count;

      // Update Subtotal Amount
      var subtotalEl = LavikaQ('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = LavikaFormatMoney(original_subtotal);

      // Update Discounts Applied
      var discountsTotalEl = LavikaQ('[data-cart-discounts-total]');
      if (discountsTotalEl) discountsTotalEl.textContent = '-' + LavikaFormatMoney(total_discounts_applied);

      // Update Total (checkout button only — no summary card)
      var totalEl = LavikaQ('[data-cart-total]');
      if (totalEl) totalEl.textContent = LavikaFormatMoney(cart.total_price);

      // Update Checkout Button price
      var checkoutPrice = LavikaQ('[data-cart-total-btn]');
      if (checkoutPrice) {
        checkoutPrice.textContent = LavikaFormatMoney(cart.total_price);
      }

      // Update Checkout Button savings
      var checkoutSavings = LavikaQ('[data-cart-total-savings]');
      if (checkoutSavings) {
        if (total_discounts_applied > 0) {
          checkoutSavings.style.display = 'block';
          checkoutSavings.textContent = 'You Save ' + LavikaFormatMoney(total_discounts_applied);
        } else {
          checkoutSavings.style.display = 'none';
        }
      }

      // Update Savings Banner Ribbon
      var savingsBannerEl = LavikaQ('[data-cart-savings-banner]');
      if (savingsBannerEl) {
        if (settings.showSavingsBanner !== false && total_discounts_applied > 0) {
          var lowText = settings.savingsLowText || "✨ You're Saving {amount} Today";
          var highText = settings.savingsHighText || "🔥 Amazing Deal! You're Saving {amount} Today";
          var template = (total_discounts_applied >= 100000) ? highText : lowText;
          var amountText = LavikaFormatMoney(total_discounts_applied);
          savingsBannerEl.textContent = template.replace('{amount}', amountText);
          savingsBannerEl.style.display = 'block';
        } else {
          savingsBannerEl.style.display = 'none';
        }
      }


    } catch (e) {
      console.warn('[Lavika] footer render error:', e);
    }
  },
  all: function (cart) {
    // 1. Render immediately with whatever compare_at prices we currently have
    LavikaRender._run(cart);

    // 2. Look for any variant IDs that are missing compare_at_price
    window.LavikaCompareAtMap = window.LavikaCompareAtMap || {};
    var missingHandles = [];
    if (cart && cart.items) {
      cart.items.forEach(function (item) {
        if (typeof window.LavikaCompareAtMap[item.variant_id] === 'undefined') {
          if (item.handle && missingHandles.indexOf(item.handle) === -1) {
            missingHandles.push(item.handle);
          }
        }
      });
    }

    // 3. If there are missing, fetch them and re-render
    if (missingHandles.length > 0) {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '';
      if (rootUrl === '/') rootUrl = '';

      var promises = missingHandles.map(function (handle) {
        return fetch(rootUrl + '/products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      });

      Promise.all(promises).then(function (products) {
        var didUpdate = false;
        products.filter(Boolean).forEach(function (product) {
          if (product.variants) {
            product.variants.forEach(function (variant) {
              if (typeof window.LavikaCompareAtMap[variant.id] === 'undefined' || window.LavikaCompareAtMap[variant.id] !== (variant.compare_at_price || 0)) {
                window.LavikaCompareAtMap[variant.id] = variant.compare_at_price || 0;
                didUpdate = true;
              }
            });
          }
        });
        // Only re-render if we actually found and loaded new compare prices
        if (didUpdate) {
          LavikaRender._run(cart);
        }
      });
    }
  },
  _run: function (cart) {
    LavikaRender.header(cart);
    LavikaRender.footer(cart);
    LavikaRender.progress(cart);
    LavikaRender.items(cart);
    LavikaRender.upsell(cart);
  }
};

window.LavikaLastTier = 0;
window.LavikaLastTotalPrice = 0;
window.LavikaRefreshing = null;
window.LavikaCheckTiers = function (cart) {
  try {
    if (!cart) return;
    var settings = window.LavikaParseDataSettings();
    if (settings.showRewardsTracker === false) return;
    var total = parseFloat(cart.total_price) || 0;
    var tiers = LavikaGetTiers();
    var reached = 0;
    for (var i = 0; i < tiers.length; i++) {
      if (total >= tiers[i].threshold) reached = i + 1;
    }
    if (reached > LavikaLastTier) {
      if (LavikaLastTier > 0 && total > window.LavikaLastTotalPrice) {
        var t = tiers[reached - 1];
        LavikaConfetti();
        LavikaToast(t.emoji + ' ' + t.name + ' unlocked!', 'success');
        // Animate new tier grid columns
        var tierCols = LavikaQA('.cart-drawer__progress-tier-col');
        var el = tierCols[reached - 1];
        if (el) {
          el.classList.remove('is-just-achieved');
          void el.offsetWidth;
          el.classList.add('is-just-achieved');
        }
      }
      LavikaLastTier = reached;
    } else if (reached < LavikaLastTier) {
      LavikaLastTier = reached;
    }
    window.LavikaLastTotalPrice = total;
  } catch (e) { }
};

window.LavikaCheckOrganiser = function (cart) {
  if (!cart) return Promise.resolve(null);

  var settings = window.LavikaParseDataSettings();

  var tier3VariantId = settings.tier3VariantId ? String(settings.tier3VariantId) : '';
  var tier2VariantId = settings.tier2VariantId ? String(settings.tier2VariantId) : '';

  // 1. Strict Conditional Guard for disabled rewards tracker
  if (settings.showRewardsTracker === false) {
    var itemsToRemove = {};
    var hasItemsToRemove = false;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var itemVarId = String(items[i].variant_id);
      if ((tier3VariantId && itemVarId === tier3VariantId) || (tier2VariantId && itemVarId === tier2VariantId)) {
        itemsToRemove['updates[' + items[i].key + ']'] = 0;
        hasItemsToRemove = true;
      }
    }
    if (hasItemsToRemove) {
      window.LavikaLog('Rewards tracker is disabled but reward items are in cart. Performing automated session cleansing...');
      return window.LavikaFetch('/cart/update.js', itemsToRemove)
        .then(function () {
          return window.LavikaGetCart();
        })
        .catch(function (err) {
          console.warn('[Lavika] Failed to cleanse cart session:', err);
          return cart;
        });
    }
    return Promise.resolve(cart);
  }

  var tier2Threshold = 69900;
  var tier3Threshold = 119900;
  try {
    var tiers = window.LavikaGetTiers();
    if (tiers && tiers[1]) tier2Threshold = tiers[1].threshold;
    if (tiers && tiers[2]) tier3Threshold = tiers[2].threshold;
  } catch (e) { }

  var hasGift = false;
  var giftKey = null;
  var giftLinePrice = 0;
  var hasOrganiser = false;
  var organiserKey = null;
  var organiserLinePrice = 0;
  var items = cart.items || [];

  for (var i = 0; i < items.length; i++) {
    var itemVarId = String(items[i].variant_id);
    if (tier2VariantId && itemVarId === tier2VariantId) {
      hasGift = true;
      giftKey = items[i].key;
      giftLinePrice = items[i].final_line_price || 0;
    }
    if (tier3VariantId && itemVarId === tier3VariantId) {
      hasOrganiser = true;
      organiserKey = items[i].key;
      organiserLinePrice = items[i].final_line_price || 0;
    }
  }

  // Calculate cart total excluding both reward line items
  var totalWithoutRewards = (cart.total_price || 0) - giftLinePrice - organiserLinePrice;

  var updates = {};
  var needsUpdate = false;
  var itemsToAdd = [];

  // Check gift (tier 2)
  if (tier2VariantId) {
    if (totalWithoutRewards >= tier2Threshold) {
      if (!hasGift) {
        itemsToAdd.push({ id: tier2VariantId, quantity: 1 });
      }
    } else {
      if (hasGift) {
        updates[giftKey] = 0;
        needsUpdate = true;
      }
    }
  }

  // Check organiser (tier 3)
  if (tier3VariantId) {
    if (totalWithoutRewards >= tier3Threshold) {
      if (!hasOrganiser) {
        itemsToAdd.push({ id: tier3VariantId, quantity: 1 });
      }
    } else {
      if (hasOrganiser) {
        updates[organiserKey] = 0;
        needsUpdate = true;
      }
    }
  }

  var chain = Promise.resolve(cart);

  if (needsUpdate) {
    chain = chain.then(function () {
      var payload = {};
      for (var k in updates) {
        payload['updates[' + k + ']'] = updates[k];
      }
      window.LavikaLog('Updating rewards in session...');
      return window.LavikaFetch('/cart/update.js', payload);
    });
  }

  if (itemsToAdd.length > 0) {
    chain = chain.then(function () {
      var addPromise = Promise.resolve();
      itemsToAdd.forEach(function (item) {
        addPromise = addPromise.then(function () {
          window.LavikaLog('Adding reward item: ' + item.id);
          return window.LavikaFetch('/cart/add.js', item);
        });
      });
      return addPromise;
    });
  }

  if (needsUpdate || itemsToAdd.length > 0) {
    return chain.then(function () {
      return window.LavikaGetCart();
    }).catch(function (err) {
      console.warn('[Lavika] Failed to update rewards:', err);
      return cart;
    });
  }

  return chain;
};

window.LavikaRefresh = function (force) {
  if (window.location.pathname.indexOf('/cart') !== -1 && window.location.pathname.indexOf('/cart.js') === -1) {
    window.location.reload();
    return Promise.resolve(null);
  }
  if (force) {
    window.LavikaRefreshing = null;
  }
  if (window.LavikaRefreshing) {
    return LavikaRefreshing;
  }
  LavikaSetLoading(true);
  LavikaRefreshing = LavikaGetCart()
    .then(function (cart) {
      return window.LavikaCheckOrganiser(cart);
    })
    .then(function (cart) {
      if (cart) {
        LavikaRender.all(cart);
        LavikaCheckTiers(cart);
      }
      return cart;
    })
    .catch(function () { return null; })
    .then(function (cart) {
      LavikaSetLoading(false);
      window.LavikaRefreshing = null;
      return cart;
    });
  return LavikaRefreshing;
};

window.LavikaUpdateQty = function (key, qty) {
  qty = parseInt(qty, 10);
  if (isNaN(qty) || qty < 0) qty = 0;
  if (!key) return;

  var payload = {};
  payload['updates[' + key + ']'] = qty;

  LavikaSetLoading(true);
  LavikaFetch('/cart/update.js', payload)
    .then(function (cart) {
      if (window.location.pathname.indexOf('/cart') !== -1 && window.location.pathname.indexOf('/cart.js') === -1) {
        window.location.reload();
      } else {
        return window.LavikaCheckOrganiser(cart).then(function (finalCart) {
          if (finalCart) {
            LavikaRender.all(finalCart);
            LavikaCheckTiers(finalCart);
          }
          LavikaSetLoading(false);
        });
      }
    })
    .catch(function (err) {
      console.error('[Lavika] Update qty err:', err);
      LavikaRefresh(true);
      LavikaToast('Failed to update', 'error');
    });
};

window.LavikaRemoveLine = function (key) {
  if (!key) return;
  var item = LavikaQ('[data-line-key="' + key + '"]');
  if (item) item.classList.add('is-removing');

  var payload = {};
  payload['updates[' + key + ']'] = 0;

  LavikaSetLoading(true);
  LavikaFetch('/cart/update.js', payload)
    .then(function (cart) {
      if (window.location.pathname.indexOf('/cart') !== -1 && window.location.pathname.indexOf('/cart.js') === -1) {
        window.location.reload();
      } else {
        return window.LavikaCheckOrganiser(cart).then(function (finalCart) {
          if (finalCart) {
            LavikaRender.all(finalCart);
            LavikaCheckTiers(finalCart);
          }
          LavikaToast('Removed from cart', '');
          LavikaSetLoading(false);
        });
      }
    })
    .catch(function (err) {
      console.error('[Lavika] Remove line err:', err);
      LavikaRefresh(true);
      LavikaToast('Failed to remove', 'error');
    });
};

window.LavikaUpsellAdd = function (vid, btn) {
  if (!vid) return;
  LavikaSetLoading(true);
  var orig = '';
  var isIcon = false;
  if (btn) {
    isIcon = btn.classList.contains('cart-drawer__upsell-atc--style1') || btn.classList.contains('cart-drawer__upsell-atc--icon');
    btn.disabled = true;
    btn.classList.add('is-loading');
    if (!isIcon) {
      orig = btn.getAttribute('data-orig') || btn.textContent || 'Add';
      btn.setAttribute('data-orig', orig);
      btn.textContent = 'ADDING\u2026';
    }
  }
  LavikaFetch('/cart/add.js', { id: vid, quantity: 1 })
    .then(function () { return LavikaRefresh(true); })
    .then(function () {
      if (btn) {
        if (!isIcon) {
          btn.textContent = '\u2713 Added';
          btn.classList.add('is-added');
        }
        setTimeout(function () {
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('is-loading');
            btn.classList.remove('is-added');
            if (!isIcon) {
              btn.textContent = orig || 'Add';
            }
          }
        }, 1400);
      }
      LavikaToast('Added to cart \uD83C\uDF89', 'success');
      LavikaConfetti();
    })
    .catch(function () {
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (!isIcon) {
          btn.textContent = orig || 'Add';
        }
      }
      LavikaToast('Failed to add', 'error');
      LavikaRefresh();
    });
};

window.LavikaAdjustUpsellPrices = function () {
  try {
    var cards = document.querySelectorAll('.cart-drawer__upsell-card');
    cards.forEach(function (card) {
      var priceContainer = card.querySelector('.cart-drawer__upsell-price');
      if (!priceContainer) return;
      var priceNow = priceContainer.querySelector('.cart-drawer__upsell-price-now');
      var priceWas = priceContainer.querySelector('.cart-drawer__upsell-price-was');
      var priceSave = priceContainer.querySelector('.cart-drawer__upsell-price-save');
      if (!priceWas || !priceSave) return;

      priceWas.style.display = 'inline-block';
      priceSave.style.display = 'none';

      if (priceContainer.scrollWidth > priceContainer.clientWidth) {
        priceWas.style.display = 'none';
        priceSave.style.display = 'inline-block';
      }
    });
  } catch (e) { try { console.warn('[Lavika] price adjust err:', e); } catch (_) { } }
};

window.LavikaLoadUpsell = function (cart) {
  try {
    var track = LavikaQ('[data-upsell-track]');
    if (!track) return;

    // Always reload to filter out newly added items
    var loading = track.querySelector('[data-upsell-loading]');

    function renderUpsellProducts(products) {
      try {
        if (loading && loading.parentNode) loading.parentNode.removeChild(loading);

        var settings = window.LavikaParseDataSettings();
        var limit = settings.upsellLimit || 3;
        var style = settings.upsellStyle || 'style_1';

        var cartPids = [];
        var cartVids = [];
        if (cart && cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            cartPids.push(String(cart.items[i].product_id));
            cartVids.push(String(cart.items[i].variant_id));
          }
        }

        var html = '';
        var count = 0;
        for (var j = 0; j < products.length && count < limit; j++) {
          var p = products[j];
          if (cartPids.indexOf(String(p.id)) !== -1) continue;
          if (!p.variants || !p.variants.length) continue;

          var v = null, vPrice = '0', validPrices = [];
          var hasVariantInCart = false;
          for (var k = 0; k < p.variants.length; k++) {
            if (cartVids.indexOf(String(p.variants[k].id)) !== -1) {
              hasVariantInCart = true;
              break;
            }
          }
          if (hasVariantInCart) continue;

          for (var k = 0; k < p.variants.length; k++) {
            var pv = parseFloat(p.variants[k].price);
            if (!isNaN(pv) && pv > 0) {
              validPrices.push(pv);
              var capVal = p.variants[k].compare_at_price ? parseFloat(p.variants[k].compare_at_price) : 0;
              window.LavikaCompareAtMap[p.variants[k].id] = capVal * 100;
              if (!v && p.variants[k].available !== false) {
                v = p.variants[k]; vPrice = p.variants[k].price;
              }
            }
          }
          if (!v && validPrices.length) {
            for (var k2 = 0; k2 < p.variants.length; k2++) {
              var pv2 = parseFloat(p.variants[k2].price);
              if (!isNaN(pv2) && pv2 > 0) { v = p.variants[k2]; vPrice = p.variants[k2].price; break; }
            }
          }
          if (!v || parseFloat(vPrice) <= 0) continue;

          var img = '';
          if (p.image && p.image.src) img = p.image.src;
          else if (p.featured_image && p.featured_image.src) img = p.featured_image.src;
          else if (p.images && p.images.length && p.images[0].src) img = p.images[0].src;

          if (img && img.indexOf('_180x') === -1) {
            var extIndex = img.lastIndexOf('.');
            if (extIndex !== -1) {
              var ext = img.substring(extIndex);
              var base = img.substring(0, extIndex);
              var qIndex = ext.indexOf('?');
              if (qIndex !== -1) {
                var q = ext.substring(qIndex);
                var actualExt = ext.substring(0, qIndex);
                img = base + '_180x180' + actualExt + q;
              } else {
                img = base + '_180x180' + ext;
              }
            }
          }

          var rootUrl = (window.routes && window.routes.root && window.routes.root !== '/') ? window.routes.root : '';
          var handle = LavikaEscape(p.handle || '');
          var title = LavikaEscape(p.title || 'Product');
          var priceLabel = LavikaFormatPrice(vPrice);

          var priceHtml = '';
          priceHtml += '<span class="cart-drawer__upsell-price-now">' + priceLabel + '</span>';
          if (v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(vPrice)) {
            var diff = parseFloat(v.compare_at_price) - parseFloat(vPrice);
            var saveText = 'Save ₹' + Math.round(diff);
            priceHtml += ' <span class="cart-drawer__upsell-price-was">' + LavikaFormatPrice(v.compare_at_price) + '</span>';
            priceHtml += ' <span class="cart-drawer__upsell-price-save">' + saveText + '</span>';
          }

          var overlayHtml = '';
          var hasVariants = (p.variants && p.variants.length > 1);
          if (hasVariants) {
            overlayHtml += '<div class="cart-drawer__upsell-overlay">';
            overlayHtml += '<div class="cart-drawer__upsell-overlay-header">';
            overlayHtml += '<span class="cart-drawer__upsell-overlay-title">Choose Option</span>';
            overlayHtml += '<button type="button" class="cart-drawer__upsell-overlay-close" data-overlay-close>×</button>';
            overlayHtml += '</div>';
            overlayHtml += '<div class="cart-drawer__upsell-overlay-options">';
            for (var k3 = 0; k3 < p.variants.length; k3++) {
              var pv3 = p.variants[k3];
              if (pv3.available !== false && parseFloat(pv3.price) > 0) {
                var isChecked = (pv3.id === v.id) ? 'checked' : '';
                overlayHtml += '<label class="cart-drawer__upsell-overlay-option">' +
                  '<input type="radio" name="upsell-var-' + p.id + '" value="' + pv3.id + '" data-price="' + pv3.price + '" data-compare="' + (pv3.compare_at_price || '') + '" ' + isChecked + ' data-upsell-radio>' +
                  '<span class="cart-drawer__upsell-overlay-option-label">' + LavikaEscape(pv3.title) + '</span>' +
                  '</label>';
              }
            }
            overlayHtml += '</div>';
            overlayHtml += '<button type="button" class="cart-drawer__upsell-overlay-confirm" data-overlay-confirm data-vid="' + v.id + '">Confirm Add</button>';
            overlayHtml += '</div>';
          }

          var pct = 0;
          if (v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(vPrice)) {
            pct = Math.round((1 - parseFloat(vPrice) / parseFloat(v.compare_at_price)) * 100);
          }
          var badgeHtml = '';
          if (pct > 0) {
            badgeHtml = '<span class="cart-drawer__upsell-badge">' + pct + '% OFF</span>';
          }

          var btnHtml = '<button type="button" class="cart-drawer__upsell-atc" data-vid="' + v.id + '">Add</button>';

          html += '<div class="cart-drawer__upsell-card" data-upsell-pid="' + p.id + '" data-has-variants="' + hasVariants + '">' +
            '<a href="' + rootUrl + '/products/' + handle + '" class="cart-drawer__upsell-img">' +
            badgeHtml +
            (img ? '<img src="' + img + '" loading="lazy" alt="' + title + '">' : '<div class="cart-drawer__upsell-placeholder">🛒</div>') +
            '</a>' +
            '<div class="cart-drawer__upsell-info">' +
            '<h4 class="cart-drawer__upsell-name"><a href="' + rootUrl + '/products/' + handle + '">' + title + '</a></h4>' +
            '<div class="cart-drawer__upsell-price">' + priceHtml + '</div>' +
            btnHtml +
            '</div>' +
            overlayHtml +
            '</div>';
          count++;
        }

        var upsellContainer = LavikaQ('[data-cart-upsell]');
        if (html) {
          track.innerHTML = html;
          if (typeof window.LavikaAdjustUpsellPrices === 'function') {
            window.LavikaAdjustUpsellPrices();
            setTimeout(window.LavikaAdjustUpsellPrices, 50);
            setTimeout(window.LavikaAdjustUpsellPrices, 200);
          }
          if (upsellContainer && settings.enableUpsells !== false) {
            upsellContainer.removeAttribute('hidden');
          }
          track.querySelectorAll('.cart-drawer__upsell-atc').forEach(function (b) {
            b.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              var card = b.closest('.cart-drawer__upsell-card');
              if (!card) return;

              var hasVars = card.getAttribute('data-has-variants') === 'true';
              if (hasVars) {
                var overlay = card.querySelector('.cart-drawer__upsell-overlay');
                if (overlay) {
                  overlay.classList.add('is-active');
                }
              } else {
                var imgEl = card.querySelector('.cart-drawer__upsell-img img');
                if (imgEl && typeof window.LavikaAnimateFlyToCart === 'function') {
                  window.LavikaAnimateFlyToCart(imgEl);
                }
                window.LavikaUpsellAdd(parseInt(b.getAttribute('data-vid'), 10), b);
              }
            });
          });
          track.querySelectorAll('[data-overlay-close]').forEach(function (closeBtn) {
            closeBtn.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              var overlay = closeBtn.closest('.cart-drawer__upsell-overlay');
              if (overlay) {
                overlay.classList.remove('is-active');
              }
            });
          });
          track.querySelectorAll('[data-overlay-confirm]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              var card = btn.closest('.cart-drawer__upsell-card');
              var vid = parseInt(btn.getAttribute('data-vid'), 10);
              if (!vid) return;

              if (card) {
                var imgEl = card.querySelector('.cart-drawer__upsell-img img');
                if (imgEl && typeof window.LavikaAnimateFlyToCart === 'function') {
                  window.LavikaAnimateFlyToCart(imgEl);
                }
              }

              var overlay = btn.closest('.cart-drawer__upsell-overlay');
              if (overlay) {
                overlay.classList.remove('is-active');
              }

              var mainBtn = card ? card.querySelector('.cart-drawer__upsell-atc') : null;
              window.LavikaUpsellAdd(vid, mainBtn || btn);
            });
          });
          track.querySelectorAll('[data-upsell-radio]').forEach(function (radio) {
            radio.addEventListener('change', function (e) {
              var card = radio.closest('.cart-drawer__upsell-card');
              if (!card) return;

              var vid = radio.value;
              var price = radio.getAttribute('data-price');
              var compare = radio.getAttribute('data-compare');

              var confirmBtn = card.querySelector('[data-overlay-confirm]');
              if (confirmBtn) confirmBtn.setAttribute('data-vid', vid);

              var mainBtn = card.querySelector('.cart-drawer__upsell-atc');
              if (mainBtn) mainBtn.setAttribute('data-vid', vid);

              var priceEl = card.querySelector('.cart-drawer__upsell-price');
              if (priceEl) {
                var phtml = '';
                var fPrice = parseFloat(price);
                var cPrice = compare ? parseFloat(compare) : 0;
                phtml += '<span class="cart-drawer__upsell-price-now">' + LavikaFormatPrice(fPrice) + '</span>';
                if (cPrice > fPrice) {
                  var diff = cPrice - fPrice;
                  var saveText = 'Save ₹' + Math.round(diff);
                  phtml += ' <span class="cart-drawer__upsell-price-was">' + LavikaFormatPrice(cPrice) + '</span>';
                  phtml += ' <span class="cart-drawer__upsell-price-save">' + saveText + '</span>';
                }
                priceEl.innerHTML = phtml;
                if (typeof window.LavikaAdjustUpsellPrices === 'function') {
                  window.LavikaAdjustUpsellPrices();
                }
              }

              var badgeEl = card.querySelector('.cart-drawer__upsell-badge');
              var fPriceVal = parseFloat(price);
              var cPriceVal = compare ? parseFloat(compare) : 0;
              if (cPriceVal > fPriceVal) {
                var newPct = Math.round((1 - fPriceVal / cPriceVal) * 100);
                if (badgeEl) {
                  badgeEl.textContent = newPct + '% OFF';
                  badgeEl.style.display = 'block';
                } else {
                  var imgWrapper = card.querySelector('.cart-drawer__upsell-img');
                  if (imgWrapper) {
                    var newBadge = document.createElement('span');
                    newBadge.className = 'cart-drawer__upsell-badge';
                    newBadge.textContent = newPct + '% OFF';
                    imgWrapper.insertBefore(newBadge, imgWrapper.firstChild);
                  }
                }
              } else {
                if (badgeEl) {
                  badgeEl.style.display = 'none';
                }
              }
            });
          });
        } else {
          track.innerHTML = '';
          if (upsellContainer) {
            upsellContainer.setAttribute('hidden', '');
          }
        }
      } catch (e) { try { console.warn('[Lavika] upsell render err:', e); } catch (_) { } }
    }

    // Start skeleton timer
    var upsellSkeletonTimeout = setTimeout(function () {
      track.innerHTML = `
        <div class="cart-drawer__upsell-loading-skeleton" style="display: flex; gap: 8px; overflow-x: auto; width: 100%;">
          <div class="cart-drawer__upsell-card cart-drawer__upsell-card--skeleton">
            <div class="cart-drawer__upsell-img skeleton-media skeleton-block"></div>
            <div class="cart-drawer__upsell-info">
              <div class="skeleton-text-line skeleton-block" style="width: 80%; height: 11px; margin-bottom: 8px;"></div>
              <div class="skeleton-text-line skeleton-block" style="width: 50%; height: 9px; margin-bottom: 8px;"></div>
              <div class="skeleton-text-line skeleton-block" style="width: 35%; height: 12px; margin-bottom: 12px;"></div>
              <div class="skeleton-button-block skeleton-block" style="width: 100%; height: 38px; border-radius: 99px;"></div>
            </div>
          </div>
          <div class="cart-drawer__upsell-card cart-drawer__upsell-card--skeleton">
            <div class="cart-drawer__upsell-img skeleton-media skeleton-block"></div>
            <div class="cart-drawer__upsell-info">
              <div class="skeleton-text-line skeleton-block" style="width: 85%; height: 11px; margin-bottom: 8px;"></div>
              <div class="skeleton-text-line skeleton-block" style="width: 40%; height: 9px; margin-bottom: 8px;"></div>
              <div class="skeleton-text-line skeleton-block" style="width: 30%; height: 12px; margin-bottom: 12px;"></div>
              <div class="skeleton-button-block skeleton-block" style="width: 100%; height: 38px; border-radius: 99px;"></div>
            </div>
          </div>
          <div class="cart-drawer__upsell-card cart-drawer__upsell-card--skeleton">
            <div class="cart-drawer__upsell-img skeleton-media skeleton-block"></div>
            <div class="cart-drawer__upsell-info">
              <div class="skeleton-text-line skeleton-block" style="width: 75%; height: 11px; margin-bottom: 8px;"></div>
              <div class="skeleton-text-line skeleton-block" style="width: 60%; height: 9px; margin-bottom: 8px;"></div>
              <div class="skeleton-text-line skeleton-block" style="width: 35%; height: 12px; margin-bottom: 12px;"></div>
              <div class="skeleton-button-block skeleton-block" style="width: 100%; height: 38px; border-radius: 99px;"></div>
            </div>
          </div>
        </div>
      `;
    }, 150);

    fetch('/collections/frontpage/products.json?limit=20')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; })
      .then(function (data) {
        var frontpageProds = (data && data.products) || [];
        return fetch('/products.json?limit=20')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .catch(function () { return { products: [] }; })
          .then(function (d) {
            var allProds = (d && d.products) || [];
            var merged = [].concat(frontpageProds);
            var seenIds = {};
            merged.forEach(function (p) { seenIds[p.id] = true; });
            allProds.forEach(function (p) {
              if (!seenIds[p.id]) {
                merged.push(p);
                seenIds[p.id] = true;
              }
            });
            return merged;
          });
      })
      .then(function (products) {
        clearTimeout(upsellSkeletonTimeout);
        renderUpsellProducts(products);
      })
      .catch(function () {
        clearTimeout(upsellSkeletonTimeout);
        try {
          if (loading && loading.parentNode) loading.parentNode.removeChild(loading);
          track.innerHTML = '';
          var upsellContainer = LavikaQ('[data-cart-upsell]');
          if (upsellContainer) {
            upsellContainer.setAttribute('hidden', '');
          }
        } catch (_) { }
      });
  } catch (e) { }
};

window.LavikaConfetti = function () {
  try {
    var s = (window.Lavika && window.Lavika.settings) || {};
    if (s.enableConfetti === false) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var old = document.getElementById('lavika-burst');
    if (old) old.parentNode.removeChild(old);
    var c = document.createElement('div');
    c.id = 'lavika-burst';
    c.className = 'lavika-burst';

    var parent = document.querySelector('.cart-drawer__panel');
    if (parent) {
      parent.appendChild(c);
      c.style.position = 'absolute';
      // Confetti origin: Reward Section Area
      var progressEl = document.querySelector('.cart-drawer__progress') || document.querySelector('.cart-drawer__celebration');
      var topOffset = 60; // fallback default
      if (progressEl) {
        var parentRect = parent.getBoundingClientRect();
        var progressRect = progressEl.getBoundingClientRect();
        topOffset = progressRect.top - parentRect.top;
      }
      c.style.top = topOffset + 'px';
    } else {
      document.body.appendChild(c);
      c.style.position = 'fixed';
    }

    var pal = ['#E8637A', '#FDE8EC', '#9B4F60', '#FFB6C1', '#FFC0CB', '#FFD1DC', '#FF8FA3', '#C9184A'];
    var em = ['🌸', '🌷', '🌼', '💐', '✨', '🎫', '🌿'];
    var usePercent = !!parent;
    for (var i = 0; i < 60; i++) {
      var p = document.createElement('div');
      var s = i % 5;
      if (s === 0) {
        p.className = 'lavika-burst__piece lavika-burst__piece--petal';
        p.style.background = pal[Math.floor(Math.random() * pal.length)];
        var w = 10 + Math.random() * 8; p.style.width = w + 'px'; p.style.height = (w * 1.4) + 'px';
      } else if (s === 1) {
        p.className = 'lavika-burst__piece lavika-burst__piece--circle';
        p.style.background = pal[Math.floor(Math.random() * pal.length)];
        var s2 = 6 + Math.random() * 8; p.style.width = s2 + 'px'; p.style.height = s2 + 'px';
      } else if (s === 2) {
        p.className = 'lavika-burst__piece lavika-burst__piece--ring';
        p.style.borderColor = pal[Math.floor(Math.random() * pal.length)];
        var s3 = 6 + Math.random() * 8; p.style.width = s3 + 'px'; p.style.height = s3 + 'px';
      } else if (s === 3) {
        p.className = 'lavika-burst__piece lavika-burst__piece--star';
        var s4 = 10 + Math.random() * 6; p.style.width = s4 + 'px'; p.style.height = s4 + 'px';
        p.style.background = pal[Math.floor(Math.random() * pal.length)];
      } else {
        p.className = 'lavika-burst__piece lavika-burst__piece--emoji';
        p.textContent = em[Math.floor(Math.random() * em.length)];
        p.style.fontSize = (16 + Math.random() * 16) + 'px';
      }
      p.style.left = (Math.random() * 100) + (usePercent ? '%' : 'vw');
      p.style.setProperty('--drift', (Math.random() * 200 - 100) + 'px');
      p.style.setProperty('--drift2', (Math.random() * 200 - 100) + 'px');
      p.style.animationDelay = (Math.random() * 0.5) + 's';
      p.style.animationDuration = (2.5 + Math.random() * 1.8) + 's';
      c.appendChild(p);
    }
    setTimeout(function () { try { if (c.parentNode) c.parentNode.removeChild(c); } catch (_) { } }, 5000);
  } catch (e) { }
};

window.LavikaAnimateFlyToCart = function (imgEl) {
  try {
    if (!imgEl) return;

    // Find the cart icon toggle in the header
    var cartBtn = document.querySelector('[data-cart-drawer-toggle]')
      || document.querySelector('.site-header__cart')
      || document.querySelector('.header__icon--cart')
      || document.querySelector('.site-header__icon--cart');

    if (!cartBtn) return;

    var startRect = imgEl.getBoundingClientRect();
    var destRect = cartBtn.getBoundingClientRect();

    // Create floating clone
    var clone = document.createElement('div');
    clone.className = 'lavika-fly-clone';
    clone.style.position = 'fixed';
    clone.style.zIndex = '999999';
    clone.style.top = startRect.top + 'px';
    clone.style.left = startRect.left + 'px';
    clone.style.width = startRect.width + 'px';
    clone.style.height = startRect.height + 'px';
    clone.style.pointerEvents = 'none';
    clone.style.borderRadius = '8px';
    clone.style.boxShadow = '0 6px 16px rgba(0,0,0,0.15)';
    clone.style.backgroundImage = 'url(' + imgEl.src + ')';
    clone.style.backgroundSize = 'cover';
    clone.style.backgroundPosition = 'center';
    clone.style.transition = 'all 0.8s cubic-bezier(0.2, 0.8, 0.2, 1)';
    clone.style.opacity = '1';

    document.body.appendChild(clone);

    // Force reflow
    void clone.offsetWidth;

    // Apply destination styles
    clone.style.left = (destRect.left + destRect.width / 2 - 15) + 'px';
    clone.style.top = (destRect.top + destRect.height / 2 - 15) + 'px';
    clone.style.width = '30px';
    clone.style.height = '30px';
    clone.style.opacity = '0';
    clone.style.transform = 'scale(0.1) rotate(360deg)';

    // Cleanup and bounce effect after transition finishes
    setTimeout(function () {
      try {
        if (clone.parentNode) clone.parentNode.removeChild(clone);
      } catch (_) { }

      // Add a quick visual bump/bounce to the cart badge pill or cart icon
      var cartPill = document.querySelector('[data-cart-count-pill]') || cartBtn;
      if (cartPill) {
        cartPill.classList.remove('is-bumped');
        void cartPill.offsetWidth;
        cartPill.classList.add('is-bumped');
      }
    }, 850);
  } catch (e) {
    console.warn('[Lavika] Fly to cart animation error:', e);
  }
};

// Wishlist
window.LavikaWLKey = 'lavika_wishlist_v1';
window.LavikaGetWishlist = function () { try { return JSON.parse(localStorage.getItem(LavikaWLKey) || '[]'); } catch (e) { return []; } };
window.LavikaSetWishlist = function (l) {
  try {
    localStorage.setItem(LavikaWLKey, JSON.stringify(l));
    LavikaQA('[data-wishlist-count]').forEach(function (el) { el.textContent = l.length; });
  } catch (e) { }
};
window.LavikaSyncWishlistUI = function () {
  try {
    var list = LavikaGetWishlist();
    var ids = list.map(function (it) { return String(it.id); });
    LavikaQA('[data-wishlist-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', ids.indexOf(String(btn.dataset.wishlistToggle)) !== -1);
    });
  } catch (e) { }
};
window.LavikaToggleWishlist = function (id, handle) {
  try {
    id = String(id);
    var list = LavikaGetWishlist();
    var idx = -1;
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === id) { idx = i; break; }
    if (idx >= 0) { list.splice(idx, 1); LavikaToast('Removed from wishlist', ''); }
    else { list.push({ id: id, handle: handle || '' }); LavikaToast('Added to wishlist \u2764', 'success'); }
    LavikaSetWishlist(list);
    LavikaSyncWishlistUI();
  } catch (e) { }
};

window.LavikaLastActiveElement = null;
window.LavikaActiveFocusTrapCleanup = null;

window.LavikaSetupFocusTrap = function (container) {
  function handleKeyDown(e) {
    if (e.key !== 'Tab') return;
    var focusable = container.querySelectorAll('button, [href], input, select, textarea, [tabindex="0"]');
    var list = Array.prototype.slice.call(focusable).filter(function (el) {
      return el.tabIndex >= 0 && !el.disabled && el.offsetParent !== null;
    });
    if (list.length === 0) {
      e.preventDefault();
      return;
    }
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        last.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    }
  }
  document.addEventListener('keydown', handleKeyDown);
  return function () {
    document.removeEventListener('keydown', handleKeyDown);
  };
};

window.LavikaOpen = function (sel) {
  try {
    var e = LavikaQ(sel);
    if (e) {
      e.classList.add('is-open');
      e.setAttribute('aria-hidden', 'false');
      if (sel === '[data-cart-drawer]' || e.matches('[data-cart-drawer]')) {
        window.LavikaRefresh(true);
      }
      window.LavikaLastActiveElement = document.activeElement;
      setTimeout(function () {
        var focusable = e.querySelectorAll('button, [href], input, select, textarea, [tabindex="0"]');
        var list = Array.prototype.slice.call(focusable).filter(function (el) {
          return el.tabIndex >= 0 && !el.disabled && el.offsetParent !== null;
        });
        if (list.length > 0) {
          list[0].focus();
        }
      }, 50);
      if (window.LavikaActiveFocusTrapCleanup) {
        window.LavikaActiveFocusTrapCleanup();
      }
      window.LavikaActiveFocusTrapCleanup = window.LavikaSetupFocusTrap(e);
    }
    document.body.style.overflow = 'hidden';
  } catch (err) { }
};

window.LavikaClose = function (sel) {
  try {
    var e = LavikaQ(sel);
    if (e) {
      e.classList.remove('is-open');
      e.setAttribute('aria-hidden', 'true');
      if (window.LavikaActiveFocusTrapCleanup) {
        window.LavikaActiveFocusTrapCleanup();
        window.LavikaActiveFocusTrapCleanup = null;
      }
      if (window.LavikaLastActiveElement) {
        window.LavikaLastActiveElement.focus();
        window.LavikaLastActiveElement = null;
      }
    }
    document.body.style.overflow = '';
  } catch (err) { }
};

// Event delegation
document.addEventListener('click', function (e) {
  try {
    if (!e || !e.target || !e.target.closest) return;
    var t = e.target;

    var rmBtn = t.closest('[data-remove-line]');
    if (rmBtn) {
      e.preventDefault();
      e.stopPropagation();
      var rk = rmBtn.getAttribute('data-remove-line');
      LavikaRemoveLine(rk);
      return;
    }

    var stepBtn = t.closest('.qty-stepper__btn');
    if (stepBtn) {
      e.preventDefault();
      var stepper = stepBtn.closest('.qty-stepper');
      if (stepper) {
        var input = stepper.querySelector('input');
        if (input) {
          var stepAttr = stepBtn.getAttribute('data-step') || stepBtn.getAttribute('data-qty');
          var dir = stepAttr === 'inc' ? 1 : -1;
          var cur = parseInt(input.value, 10) || 1;
          var nv = Math.max(0, cur + dir);
          input.value = nv;
          var lk = input.getAttribute('data-line-key') || input.getAttribute('data-key');
          if (lk) {
            LavikaUpdateQty(lk, nv);
          } else {
            var form = stepper.closest('form');
            if (form) form.submit();
          }
        }
      }
      return;
    }

    var toggleDetailsBtn = t.closest('[data-toggle-discount-details]');
    if (toggleDetailsBtn) {
      e.preventDefault();
      var detailsList = LavikaQ('[data-discount-details-list]');
      if (detailsList) {
        var isOpen = detailsList.classList.contains('is-open');
        if (isOpen) {
          detailsList.classList.remove('is-open');
          detailsList.style.display = 'none';
          toggleDetailsBtn.textContent = 'See details';
        } else {
          detailsList.style.display = 'block';
          void detailsList.offsetHeight;
          detailsList.classList.add('is-open');
          toggleDetailsBtn.textContent = 'Hide details';
        }
      }
      return;
    }

    if (t.closest('[data-mobile-menu-toggle]')) {
      e.preventDefault();
      LavikaOpen('[data-mobile-menu]');
      var toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
      if (toggleBtn) {
        toggleBtn.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (t.closest('[data-mobile-menu-close]')) {
      LavikaClose('[data-mobile-menu]');
      var toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
      if (toggleBtn) {
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
      return;
    }
    if (t.closest('[data-search-toggle]')) { e.preventDefault(); LavikaOpen('[data-search-overlay]'); return; }
    if (t.closest('[data-search-close]')) { LavikaClose('[data-search-overlay]'); return; }
    if (t.closest('[data-cart-drawer-toggle]')) { e.preventDefault(); LavikaOpen('[data-cart-drawer]'); return; }
    if (t.closest('[data-cart-drawer-close]')) { LavikaClose('[data-cart-drawer]'); return; }
    if (t.closest('[data-exit-popup-close]')) { LavikaClose('[data-exit-popup]'); return; }
    if (t.closest('[data-filters-open]')) { e.preventDefault(); LavikaOpen('[data-collection-filters]'); LavikaOpen('[data-filters-backdrop]'); return; }
    if (t.closest('[data-filters-close]') || t.closest('[data-filters-backdrop]')) { LavikaClose('[data-collection-filters]'); LavikaClose('[data-filters-backdrop]'); return; }

    var wlBtn = t.closest('[data-wishlist-toggle]');
    if (wlBtn) { e.preventDefault(); e.stopPropagation(); LavikaToggleWishlist(wlBtn.dataset.wishlistToggle, wlBtn.dataset.wishlistHandle); return; }
  } catch (err) { }
});

document.addEventListener('change', function (e) {
  try {
    if (!e || !e.target) return;
    var t = e.target;
    if (t.classList.contains('qty-stepper__input')) {
      var nv = parseInt(t.value, 10);
      if (isNaN(nv) || nv < 1) nv = 1;
      t.value = nv;
      var lk = t.getAttribute('data-line-key') || t.getAttribute('data-key');
      LavikaUpdateQty(lk, nv);
    }
  } catch (err) { }
});

document.addEventListener('keydown', function (e) {
  try {
    if (e && e.key === 'Escape') {
      LavikaClose('[data-search-overlay]');
      LavikaClose('[data-cart-drawer]');
      LavikaClose('[data-exit-popup]');
      LavikaClose('[data-collection-filters]');
      LavikaClose('[data-filters-backdrop]');
      LavikaClose('[data-mobile-menu]');
      var toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
      if (toggleBtn) {
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
    }
  } catch (err) { }
});

window.LavikaOpenVariantSelector = function (title, variants, sourceForm) {
  var selectorId = 'lavika-variant-selector-modal';
  var modal = document.getElementById(selectorId);
  if (!modal) {
    modal = document.createElement('div');
    modal.id = selectorId;
    modal.className = 'lavika-modal';
    modal.innerHTML =
      '<div class="lavika-modal__backdrop" data-lavika-modal-close></div>' +
      '<div class="lavika-modal__container">' +
      '<div class="lavika-modal__drag-handle"></div>' +
      '<button type="button" class="lavika-modal__close" data-lavika-modal-close>&times;</button>' +
      '<div class="lavika-modal__body">' +
      '<h4 class="lavika-modal__title"></h4>' +
      '<p class="lavika-modal__subtitle">Choose Option</p>' +
      '<form class="lavika-modal__form">' +
      '<div class="lavika-modal__options"></div>' +
      '<button type="submit" class="lavika-modal__submit"></button>' +
      '</form>' +
      '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.querySelectorAll('[data-lavika-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.classList.remove('is-open');
      });
    });
  }

  // Populate title
  modal.querySelector('.lavika-modal__title').textContent = title;

  // Populate options
  var optionsContainer = modal.querySelector('.lavika-modal__options');
  optionsContainer.innerHTML = '';

  var availableVariants = variants.filter(function (v) { return v.available; });

  availableVariants.forEach(function (v, idx) {
    var label = document.createElement('label');
    label.className = 'lavika-modal__option-label';

    var priceStr = LavikaFormatMoney(v.price);

    label.innerHTML =
      '<input type="radio" name="variant_id" value="' + v.id + '" ' + (idx === 0 ? 'checked' : '') + ' data-price="' + priceStr + '">' +
      '<span class="lavika-modal__option-checkmark"></span>' +
      '<span class="lavika-modal__option-text">' + LavikaEscape(v.title) + '</span>' +
      '<span class="lavika-modal__option-price">' + priceStr + '</span>';
    optionsContainer.appendChild(label);
  });

  var submitBtn = modal.querySelector('.lavika-modal__submit');

  // Set initial button price label
  var checkedRadio = optionsContainer.querySelector('input[type="radio"]:checked');
  if (checkedRadio) {
    submitBtn.textContent = 'Add to Cart — ' + checkedRadio.getAttribute('data-price');
  } else {
    submitBtn.textContent = 'Add to Cart';
  }

  // Update button price on selection change
  optionsContainer.querySelectorAll('input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      submitBtn.textContent = 'Add to Cart — ' + radio.getAttribute('data-price');
    });
  });

  // Handle form submit
  var form = modal.querySelector('.lavika-modal__form');
  form.onsubmit = function (e) {
    e.preventDefault();
    var selectedRadio = form.querySelector('input[name="variant_id"]:checked');
    if (!selectedRadio) return;
    var variantId = selectedRadio.value;

    // Close modal
    modal.classList.remove('is-open');

    // Add to cart dynamically
    LavikaSetLoading(true);
    submitBtn.disabled = true;

    // Animate item flying to cart if possible
    var card = sourceForm.closest('.product-card');
    if (card) {
      var imgEl = card.querySelector('.product-card__img img');
      if (imgEl && typeof window.LavikaAnimateFlyToCart === 'function') {
        window.LavikaAnimateFlyToCart(imgEl);
      }
    }

    LavikaFetch('/cart/add.js', { id: variantId, quantity: 1 })
      .then(function () { return LavikaRefresh(true); })
      .then(function () {
        LavikaOpen('[data-cart-drawer]');
        LavikaToast('Added!', 'success');
      })
      .catch(function () {
        LavikaToast('Failed to add', 'error');
      })
      .then(function () {
        submitBtn.disabled = false;
        LavikaSetLoading(false);
      });
  };

  // Open modal
  void modal.offsetWidth; // Force layout
  modal.classList.add('is-open');
};

document.addEventListener('submit', function (e) {
  try {
    if (!e || !e.target || !e.target.closest) return;
    var form = e.target.closest('[data-cart-add]');
    if (!form) return;

    var hasVariants = form.getAttribute('data-has-variants') === 'true';
    if (hasVariants) {
      e.preventDefault();
      e.stopPropagation();
      var title = form.getAttribute('data-product-title');
      var variantsStr = form.getAttribute('data-variants');
      var variants = JSON.parse(variantsStr);
      window.LavikaOpenVariantSelector(title, variants, form);
      return;
    }

    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    var qtyInput = form.querySelector('[name="quantity"]');
    var id = idInput.value;
    var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
    var btn = form.querySelector('button[type="submit"]');

    LavikaSetLoading(true);

    if (btn) { btn.disabled = true; btn.textContent = 'ADDING…'; }
    LavikaFetch('/cart/add.js', { id: id, quantity: qty })
      .then(function () { return LavikaRefresh(true); })
      .then(function () { LavikaOpen('[data-cart-drawer]'); LavikaToast('Added!', 'success'); })
      .catch(function () { LavikaToast('Failed', 'error'); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = 'ADD TO CART'; } LavikaSetLoading(false); });
  } catch (err) { }
});

// Pre-fetch gift images once so they are cached before the first cart render
window.LavikaPreloadGiftImages = function () {
  try {
    var s = window.LavikaParseDataSettings();
    var t3id = s.tier3VariantId || '';
    if (!t3id) return;
    if (!window.LavikaOrganiserImageUrl && t3id) {
      fetch('/variants/' + t3id + '.js')
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (v) {
          var src = (v.featured_image && v.featured_image.src) ? v.featured_image.src : '';
          if (src) {
            window.LavikaOrganiserImageUrl = src;
          } else if (v && v.handle) {
            // Variant has no image — try product
            return fetch('/products/' + v.handle + '.js')
              .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
              .then(function (p) {
                if (p && p.images && p.images.length) window.LavikaOrganiserImageUrl = p.images[0].src;
              });
          }
        })
        .catch(function () { });
    }
  } catch (e) { }
};

// Collection Filtering and Interactive Dual Price Slider
window.LavikaInitFilters = function () {
  try {
    var form = document.getElementById('CollectionFiltersForm');
    var sortSelect = document.querySelector('[data-sort]');

    // 1. DUAL RANGE SLIDER LOGIC
    var dualRanges = document.querySelectorAll('.dual-range');
    dualRanges.forEach(function (slider) {
      var minInput = slider.querySelector('[data-range-min]');
      var maxInput = slider.querySelector('[data-range-max]');
      var labelDisplay = slider.closest('.filter-group').querySelector('[data-label-display]');
      var maxLimit = parseFloat(slider.getAttribute('data-max-limit')) || 100;

      var trackHighlight = slider.querySelector('.dual-range__track-highlight');
      if (!trackHighlight) {
        trackHighlight = document.createElement('div');
        trackHighlight.className = 'dual-range__track-highlight';
        slider.querySelector('[data-track]').appendChild(trackHighlight);
      }

      function updateSliderUI() {
        var minVal = parseFloat(minInput.value) || 0;
        var maxVal = parseFloat(maxInput.value) || 0;

        // Prevent values crossing
        if (minVal > maxVal) {
          var temp = minVal;
          minVal = maxVal;
          maxVal = temp;
          minInput.value = minVal;
          maxInput.value = maxVal;
        }

        // Calculate percent
        var minPercent = (minVal / maxLimit) * 100;
        var maxPercent = (maxVal / maxLimit) * 100;

        trackHighlight.style.left = minPercent + '%';
        trackHighlight.style.width = (maxPercent - minPercent) + '%';

        if (labelDisplay) {
          var currencySym = labelDisplay.textContent.match(/[^\d\s\-\.\u20B9\u0024\u00A3\u20AC]+/g) || ['Rs. '];
          var symbol = currencySym[0].trim() || 'Rs. ';
          labelDisplay.textContent = symbol + ' ' + Math.round(minVal).toLocaleString() + ' - ' + symbol + ' ' + Math.round(maxVal).toLocaleString();
        }
      }

      minInput.addEventListener('input', updateSliderUI);
      maxInput.addEventListener('input', updateSliderUI);

      minInput.addEventListener('change', function () {
        window.LavikaSubmitFilters();
      });
      maxInput.addEventListener('change', function () {
        window.LavikaSubmitFilters();
      });

      updateSliderUI();
    });

    // 2. FORM CHANGE EVENT
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'range') return;
        window.LavikaSubmitFilters();
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }

    // 3. SORT DROP DOWN CHANGE
    if (sortSelect) {
      if (!sortSelect.dataset.listenerBound) {
        sortSelect.addEventListener('change', function () {
          window.LavikaSubmitFilters();
        });
        sortSelect.dataset.listenerBound = 'true';
      }
    }

    // 4. INFINITE SCROLL INITIALIZATION
    window.LavikaInitInfiniteScroll();
  } catch (e) {
    console.error('[Lavika] Filters Init Error:', e);
  }
};

window.LavikaSubmitFilters = function () {
  try {
    var form = document.getElementById('CollectionFiltersForm');
    var grid = document.querySelector('[data-collection-grid]');
    var sortSelect = document.querySelector('[data-sort]');

    if (!form || !grid) return;

    var skeletonTimeout = setTimeout(function () {
      grid.innerHTML = `
        <div class="product-card product-card--skeleton">
          <div class="product-card__media skeleton-media skeleton-block"></div>
          <div class="product-card__body">
            <div class="skeleton-text-line skeleton-block" style="width: 75%; height: 14px;"></div>
            <div class="skeleton-text-line skeleton-block" style="width: 50%; height: 12px;"></div>
            <div class="skeleton-price-block skeleton-block"></div>
            <div class="skeleton-button-block skeleton-block"></div>
          </div>
        </div>
        <div class="product-card product-card--skeleton">
          <div class="product-card__media skeleton-media skeleton-block"></div>
          <div class="product-card__body">
            <div class="skeleton-text-line skeleton-block" style="width: 80%; height: 14px;"></div>
            <div class="skeleton-text-line skeleton-block" style="width: 45%; height: 12px;"></div>
            <div class="skeleton-price-block skeleton-block"></div>
            <div class="skeleton-button-block skeleton-block"></div>
          </div>
        </div>
        <div class="product-card product-card--skeleton">
          <div class="product-card__media skeleton-media skeleton-block"></div>
          <div class="product-card__body">
            <div class="skeleton-text-line skeleton-block" style="width: 70%; height: 14px;"></div>
            <div class="skeleton-text-line skeleton-block" style="width: 55%; height: 12px;"></div>
            <div class="skeleton-price-block skeleton-block"></div>
            <div class="skeleton-button-block skeleton-block"></div>
          </div>
        </div>
        <div class="product-card product-card--skeleton">
          <div class="product-card__media skeleton-media skeleton-block"></div>
          <div class="product-card__body">
            <div class="skeleton-text-line skeleton-block" style="width: 85%; height: 14px;"></div>
            <div class="skeleton-text-line skeleton-block" style="width: 40%; height: 12px;"></div>
            <div class="skeleton-price-block skeleton-block"></div>
            <div class="skeleton-button-block skeleton-block"></div>
          </div>
        </div>
      `;
    }, 150);

    grid.classList.add('is-loading');

    var formData = new FormData(form);
    var params = new URLSearchParams(formData);

    // Only submit price range filters if they have been adjusted from their defaults
    var dualRanges = document.querySelectorAll('.dual-range');
    dualRanges.forEach(function (slider) {
      var minInput = slider.querySelector('[data-range-min]');
      var maxInput = slider.querySelector('[data-range-max]');
      var maxLimit = parseFloat(slider.getAttribute('data-max-limit')) || 100;
      if (minInput && maxInput) {
        var minVal = parseFloat(minInput.value) || 0;
        var maxVal = parseFloat(maxInput.value) || 0;
        if (minVal === 0 && maxVal === maxLimit) {
          params.delete(minInput.name);
          params.delete(maxInput.name);
        }
      }
    });

    if (sortSelect) {
      params.set('sort_by', sortSelect.value);
    }

    var requestUrl = window.location.pathname + '?' + params.toString();
    console.log('[Lavika Filters] Requesting URL:', requestUrl);
    console.log('[Lavika Filters] Active parameters:', Object.fromEntries(params.entries()));

    fetch(requestUrl)
      .then(function (res) {
        console.log('[Lavika Filters] AJAX Response Status:', res.status);
        return res.text();
      })
      .then(function (html) {
        clearTimeout(skeletonTimeout);
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newGrid = doc.querySelector('[data-collection-grid]');
        if (newGrid) {
          console.log('[Lavika Filters] Found new grid cards count:', newGrid.querySelectorAll('.product-card').length);
          grid.innerHTML = newGrid.innerHTML;
        }

        var newToolbar = doc.querySelector('[data-collection-toolbar]');
        var currentToolbar = document.querySelector('[data-collection-toolbar]');
        if (newToolbar && currentToolbar) {
          var activeSort = sortSelect ? sortSelect.value : '';
          currentToolbar.innerHTML = newToolbar.innerHTML;
          sortSelect = document.querySelector('[data-sort]');
          if (sortSelect && activeSort) {
            sortSelect.value = activeSort;
          }
        }

        var newFilters = doc.querySelector('[data-collection-filters]');
        var currentFilters = document.querySelector('[data-collection-filters]');
        if (newFilters && currentFilters) {
          var isOpen = currentFilters.classList.contains('is-open');

          // Save the open state of details elements
          var openStates = [];
          currentFilters.querySelectorAll('details.filter-group').forEach(function (details, idx) {
            openStates[idx] = details.hasAttribute('open');
          });

          currentFilters.innerHTML = newFilters.innerHTML;

          // Restore the open state of details elements
          currentFilters.querySelectorAll('details.filter-group').forEach(function (details, idx) {
            if (openStates[idx] !== undefined) {
              if (openStates[idx]) {
                details.setAttribute('open', '');
              } else {
                details.removeAttribute('open');
              }
            }
          });

          if (isOpen) {
            currentFilters.classList.add('is-open');
            var backdrop = document.querySelector('[data-filters-backdrop]');
            if (backdrop) backdrop.classList.add('is-open');
          }
        }

        history.pushState({ path: requestUrl }, '', requestUrl);

        window.LavikaInitFilters();

        if (window.LavikaSyncWishlistUI) window.LavikaSyncWishlistUI();
      })
      .catch(function (err) {
        clearTimeout(skeletonTimeout);
        console.error('[Lavika] AJAX Filter Error:', err);
      })
      .finally(function () {
        clearTimeout(skeletonTimeout);
        grid.classList.remove('is-loading');
      });
  } catch (e) {
    console.error('[Lavika] AJAX Submit Error:', e);
  }
};

// Load More Button
window.LavikaInitInfiniteScroll = function () {
  try {
    var trigger = document.querySelector('.collection__load-more-trigger');
    var btn = document.querySelector('[data-load-more-btn]');
    var label = document.querySelector('[data-load-more-label]');
    var bar = document.querySelector('[data-load-more-bar]');
    var wrap = document.querySelector('[data-load-more-wrap]');
    var allDone = document.querySelector('[data-all-loaded]');
    var grid = document.querySelector('[data-collection-grid]');

    // Toggle wrap visibility depending on whether a next page trigger exists
    if (!trigger) {
      if (wrap) wrap.style.display = 'none';
      return;
    } else {
      if (wrap) wrap.style.display = 'flex';
      if (btn) btn.style.display = 'inline-flex';
      if (allDone) allDone.style.display = 'none';
    }

    if (!btn || !grid) return;

    // Prevent duplicate event listener bindings
    if (btn.dataset.infiniteScrollBound) {
      return;
    }
    btn.dataset.infiniteScrollBound = 'true';

    var fetching = false;

    btn.addEventListener('click', function () {
      if (fetching) return;
      var activeTrigger = document.querySelector('.collection__load-more-trigger');
      if (!activeTrigger) return;
      var nextUrl = activeTrigger.getAttribute('data-next-url');
      if (!nextUrl) return;

      fetching = true;
      btn.disabled = true;
      if (label) label.textContent = 'Loading…';
      if (bar) bar.classList.remove('is-hidden');

      var infiniteScrollSkeletonTimeout = setTimeout(function () {
        var skelContainer = document.createElement('div');
        skelContainer.className = 'collection-pagination-skeletons';
        skelContainer.style.display = 'contents';
        skelContainer.innerHTML = `
          <div class="product-card product-card--skeleton">
            <div class="product-card__media skeleton-media skeleton-block"></div>
            <div class="product-card__body">
              <div class="skeleton-text-line skeleton-block" style="width: 75%; height: 14px;"></div>
              <div class="skeleton-text-line skeleton-block" style="width: 50%; height: 12px;"></div>
              <div class="skeleton-price-block skeleton-block"></div>
              <div class="skeleton-button-block skeleton-block"></div>
            </div>
          </div>
          <div class="product-card product-card--skeleton">
            <div class="product-card__media skeleton-media skeleton-block"></div>
            <div class="product-card__body">
              <div class="skeleton-text-line skeleton-block" style="width: 80%; height: 14px;"></div>
              <div class="skeleton-text-line skeleton-block" style="width: 45%; height: 12px;"></div>
              <div class="skeleton-price-block skeleton-block"></div>
              <div class="skeleton-button-block skeleton-block"></div>
            </div>
          </div>
          <div class="product-card product-card--skeleton">
            <div class="product-card__media skeleton-media skeleton-block"></div>
            <div class="product-card__body">
              <div class="skeleton-text-line skeleton-block" style="width: 70%; height: 14px;"></div>
              <div class="skeleton-text-line skeleton-block" style="width: 55%; height: 12px;"></div>
              <div class="skeleton-price-block skeleton-block"></div>
              <div class="skeleton-button-block skeleton-block"></div>
            </div>
          </div>
          <div class="product-card product-card--skeleton">
            <div class="product-card__media skeleton-media skeleton-block"></div>
            <div class="product-card__body">
              <div class="skeleton-text-line skeleton-block" style="width: 85%; height: 14px;"></div>
              <div class="skeleton-text-line skeleton-block" style="width: 40%; height: 12px;"></div>
              <div class="skeleton-price-block skeleton-block"></div>
              <div class="skeleton-button-block skeleton-block"></div>
            </div>
          </div>
        `;
        grid.appendChild(skelContainer);
        window.LavikaPaginationSkelContainer = skelContainer;
      }, 150);

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          clearTimeout(infiniteScrollSkeletonTimeout);
          var skel = window.LavikaPaginationSkelContainer;
          if (skel && skel.parentNode) {
            skel.parentNode.removeChild(skel);
            window.LavikaPaginationSkelContainer = null;
          }

          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          // Append new product cards
          var newCards = doc.querySelectorAll('[data-collection-grid] .product-card');
          var currentGrid = document.querySelector('[data-collection-grid]');
          newCards.forEach(function (card) { currentGrid.appendChild(card); });

          // Sync wishlist hearts on new cards
          if (window.LavikaSyncWishlistUI) window.LavikaSyncWishlistUI();

          // Check for another page
          var newTrigger = doc.querySelector('.collection__load-more-trigger');
          var currentTrigger = document.querySelector('.collection__load-more-trigger');
          if (newTrigger && newTrigger.getAttribute('data-next-url') && currentTrigger) {
            currentTrigger.setAttribute('data-next-url', newTrigger.getAttribute('data-next-url'));
            fetching = false;
            btn.disabled = false;
            if (label) label.textContent = 'Load More Products';
            if (bar) bar.classList.add('is-hidden');
          } else {
            // All products loaded
            if (currentTrigger) currentTrigger.removeAttribute('data-next-url');
            if (btn) btn.style.display = 'none';
            if (bar) bar.classList.add('is-hidden');
            if (allDone) allDone.style.display = 'block';
          }
        })
        .catch(function (err) {
          clearTimeout(infiniteScrollSkeletonTimeout);
          var skel = window.LavikaPaginationSkelContainer;
          if (skel && skel.parentNode) {
            skel.parentNode.removeChild(skel);
            window.LavikaPaginationSkelContainer = null;
          }

          console.error('[Lavika] Load More error:', err);
          fetching = false;
          btn.disabled = false;
          if (label) label.textContent = 'Try Again';
          if (bar) bar.classList.add('is-hidden');
        });
    });

  } catch (e) {
    console.error('[Lavika] Load More Init Error:', e);
  }
};


// Init
window.LavikaInitCountdowns = function () {
  try {
    function updateTimers() {
      var timers = document.querySelectorAll('[data-countdown]');
      if (!timers.length) return;

      var now = new Date().getTime();

      timers.forEach(function (el) {
        var dateStr = el.getAttribute('data-countdown');
        var targetTime = 0;

        if (dateStr && dateStr.trim() !== '') {
          targetTime = new Date(dateStr).getTime();
        }

        // Fallback: Tonight at 12:00 AM (midnight of the current day)
        if (isNaN(targetTime) || targetTime <= now) {
          var midnight = new Date();
          midnight.setHours(24, 0, 0, 0);
          targetTime = midnight.getTime();
        }

        var diff = targetTime - now;
        if (diff < 0) diff = 0;

        var seconds = Math.floor((diff / 1000) % 60);
        var minutes = Math.floor((diff / 1000 / 60) % 60);
        var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));

        var dStr = days > 0 ? days + 'd ' : '';
        var hStr = ('0' + hours).slice(-2);
        var mStr = ('0' + minutes).slice(-2);
        var sStr = ('0' + seconds).slice(-2);

        var hoursEl = el.querySelector('[data-hours]');
        var minsEl = el.querySelector('[data-minutes]');
        var secsEl = el.querySelector('[data-seconds]');

        if (hoursEl && minsEl && secsEl) {
          hoursEl.textContent = hStr;
          minsEl.textContent = mStr;
          secsEl.textContent = sStr;
        } else {
          el.textContent = 'Ends in: ' + dStr + hStr + 'h ' + mStr + 'm ' + sStr + 's';
        }
      });
    }

    updateTimers();
    setInterval(updateTimers, 1000);
  } catch (e) {
    console.error('[Lavika] Countdown Init Error:', e);
  }
};

window.LavikaGo = function () {
  try {
    LavikaLog('init');
    LavikaPreloadGiftImages();
    if (LavikaQ('[data-cart-drawer]')) LavikaRefresh();
    LavikaSetWishlist(LavikaGetWishlist());
    LavikaSyncWishlistUI();
    window.LavikaInitFilters();
    window.LavikaInitCountdowns();
  } catch (e) { }
};

if (document.readyState === 'complete') {
  setTimeout(LavikaGo, 50);
} else {
  window.addEventListener('load', function () { setTimeout(LavikaGo, 50); });
}

document.addEventListener('shopify:section:load', function (e) {
  try {
    var sectionContainer = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
    if (sectionContainer) {
      if (sectionContainer.classList.contains('collection')) {
        window.LavikaInitFilters();
      }
      if (sectionContainer.querySelector('[data-cart-drawer]') || sectionContainer.matches('[data-cart-drawer]')) {
        window.LavikaParseDataSettings();
        window.LavikaRefresh(true).then(function () {
          window.LavikaOpen('[data-cart-drawer]');
        });
      }
    }
  } catch (err) { }
});

document.addEventListener('shopify:section:select', function (e) {
  try {
    var sectionContainer = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
    if (sectionContainer && (sectionContainer.querySelector('[data-cart-drawer]') || sectionContainer.matches('[data-cart-drawer]'))) {
      window.LavikaOpen('[data-cart-drawer]');
    }
  } catch (err) { }
});


/* ── Reel Video FAB + Modal Controller ── */
(function () {
  'use strict';

  var reels = [];          // array of {url, caption, handle, label}
  var currentIndex = 0;
  var isOpen = false;

  /* ─── DOM refs (resolved after DOMContentLoaded) ─── */
  var fab, modal, overlay, video, closeBtn, prevBtn, nextBtn,
      labelEl, captionEl, handleEl, counterEl, previewVideo;

  function resolveElements() {
    fab        = document.getElementById('reel-fab');
    modal      = document.getElementById('reel-modal');
    overlay    = document.getElementById('reel-modal-overlay');
    video      = document.getElementById('reel-modal-video');
    closeBtn   = document.getElementById('reel-modal-close');
    prevBtn    = document.getElementById('reel-modal-prev');
    nextBtn    = document.getElementById('reel-modal-next');
    labelEl    = document.getElementById('reel-modal-label');
    captionEl  = document.getElementById('reel-modal-caption');
    handleEl   = document.getElementById('reel-modal-handle');
    counterEl  = document.getElementById('reel-modal-counter');
    previewVideo = document.getElementById('reel-fab-video-preview');
  }

  /* ─── Load reel data from JSON script tag ─── */
  function loadReelData() {
    try {
      var scriptTag = document.getElementById('reel-videos-data');
      if (!scriptTag) return;
      var parsed = JSON.parse(scriptTag.textContent);
      if (Array.isArray(parsed) && parsed.length > 0) {
        reels = parsed.filter(function (r) { return r.url; });
      }
    } catch (e) { }
  }

  /* ─── Show / hide FAB ─── */
  function initFab() {
    if (!fab || reels.length === 0) return;
    fab.style.display = 'flex';
    fab.addEventListener('click', openModal);
    
    // Set first video as the source of the mini preview bubble
    if (previewVideo && reels[0].url) {
      previewVideo.src = reels[0].url;
      previewVideo.load();
      previewVideo.play().catch(function () {});
    }
  }

  /* ─── Open modal at given index ─── */
  function openModal(startIndex) {
    if (!modal || reels.length === 0) return;
    currentIndex = typeof startIndex === 'number' ? startIndex : 0;
    loadVideo(currentIndex);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    isOpen = true;
    updateNav();
    if (video) video.play().catch(function () {});
    if (previewVideo) previewVideo.pause();
  }

  /* ─── Close modal ─── */
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    isOpen = false;
    if (video) { video.pause(); video.src = ''; }
    if (previewVideo) previewVideo.play().catch(function () {});
  }

  /* ─── Load video at index ─── */
  function loadVideo(idx) {
    var reel = reels[idx];
    if (!reel || !video) return;
    video.src = reel.url;
    video.load();
    if (labelEl)   labelEl.textContent   = reel.label   || '';
    if (captionEl) captionEl.textContent = reel.caption  || '';
    if (handleEl)  handleEl.textContent  = reel.handle   || '';
    if (counterEl) counterEl.textContent = reels.length > 1
      ? (idx + 1) + ' / ' + reels.length : '';
  }

  /* ─── Enable / disable nav arrows ─── */
  function updateNav() {
    if (!prevBtn || !nextBtn) return;
    var show = reels.length > 1;
    prevBtn.style.display = show ? '' : 'none';
    nextBtn.style.display = show ? '' : 'none';
    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex === reels.length - 1;
  }

  function goNext() {
    if (currentIndex < reels.length - 1) {
      currentIndex++;
      loadVideo(currentIndex);
      updateNav();
      if (video) video.play().catch(function () {});
    }
  }

  function goPrev() {
    if (currentIndex > 0) {
      currentIndex--;
      loadVideo(currentIndex);
      updateNav();
      if (video) video.play().catch(function () {});
    }
  }

  /* ─── Swipe support (mobile) ─── */
  var touchStartX = 0;
  function onTouchStart(e) { touchStartX = e.touches[0].clientX; }
  function onTouchEnd(e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) { diff > 0 ? goNext() : goPrev(); }
  }

  /* ─── Bind all events ─── */
  function bindEvents() {
    if (closeBtn)  closeBtn.addEventListener('click', closeModal);
    if (overlay)   overlay.addEventListener('click', closeModal);
    if (nextBtn)   nextBtn.addEventListener('click', goNext);
    if (prevBtn)   prevBtn.addEventListener('click', goPrev);
    if (modal) {
      modal.addEventListener('touchstart', onTouchStart, { passive: true });
      modal.addEventListener('touchend',   onTouchEnd,   { passive: true });
    }
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape')      closeModal();
      if (e.key === 'ArrowRight')  goNext();
      if (e.key === 'ArrowLeft')   goPrev();
    });
  }

  /* ─── Init ─── */
  function init() {
    resolveElements();
    loadReelData();
    initFab();
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


